// src/Routes.jsx

import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";

// Pages are site-specific, so they stay under "pages/…"
import Home from "./pages/Home";
import Auctions from "./pages/Auctions";
import AnalysisSSP from "./pages/AnalysisSSP";
import Analysis from "./pages/Analysis";
import CompetitorAnalysis from "./pages/CompetitorAnalysis";
import IndicatorDynamic from "./pages/IndicatorDynamic";
import PeriodMonitoring from "./pages/PeriodMonitoring";
import PeriodMonitoringSSP from "./pages/PeriodMonitoringSSP";
import Participants from "./pages/Participants";
import ParticipantsCard from "./pages/ParticipantsCard";
import Contracts from "./pages/Contracts";
import Questions from "./pages/Questions";
import Sites from "./pages/Sites";
import Organizers from "./pages/Organizers";
import OrganizerCard from "./pages/OrganizerCard";
import Geography from "./pages/Geography";
import BestResults from "./pages/BestResults";
import Selections from "./pages/Selections";
import Assets from "./pages/Assets";
import AssetItems from "./pages/AssetItems";
import AssetsSSP from "./pages/AssetsSSP";
import IncomeDynamics from "./pages/IncomeDynamics";
import LeaseRegistry from "./pages/LeaseRegistry";
import LeaseContracts from "./pages/LeaseContracts";
import ProcedureType from "./pages/ProcedureType";
import DirectionAnalysis from "./pages/DirectionAnalysis";
import AnalyticTotal from "./pages/AnalyticTotal";
import OrganizerResults from "./pages/OrganizerResults";
import DisqualifiedBilling from "./pages/DisqualifiedBilling";

export default function Routes({ menuLayout }) {
  return (
    <RouterRoutes>
      <Route
        path="/"
        element={
          <Home
            title={menuLayout.MenuItem1}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            isAppReady={menuLayout.isAppReady}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/auctions"
        element={
          <Auctions
            title={menuLayout.MenuItem2}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/analysisSSP"
        element={
          <AnalysisSSP
            title={menuLayout.MenuItem3}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/analysis"
        element={
          <Analysis
            title={menuLayout.MenuItem4}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/competitorAnalysis"
        element={
          <CompetitorAnalysis
            title={menuLayout.MenuItem5}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/indicatorDynamic"
        element={
          <IndicatorDynamic
            title={menuLayout.MenuItem6}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/periodMonitoring"
        element={
          <PeriodMonitoring
            title={menuLayout.MenuItem7}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/periodMonitoringSSP"
        element={
          <PeriodMonitoringSSP
            title={menuLayout.MenuItem8}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/participants"
        element={
          <Participants
            title={menuLayout.MenuItem9}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/participantsCard"
        element={
          <ParticipantsCard
            title={menuLayout.MenuItem10}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/contracts"
        element={
          <Contracts
            title={menuLayout.MenuItem11}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/questions"
        element={
          <Questions
            title={menuLayout.MenuItem12}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/sites"
        element={
          <Sites
            title={menuLayout.MenuItem13}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/organizers"
        element={
          <Organizers
            title={menuLayout.MenuItem14}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/organizerCard"
        element={
          <OrganizerCard
            title={menuLayout.MenuItem15}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/geography"
        element={
          <Geography
            title={menuLayout.MenuItem16}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/bestResults"
        element={
          <BestResults
            title={menuLayout.MenuItem17}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/selections"
        element={
          <Selections
            title={menuLayout.MenuItem18}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/assets"
        element={
          <Assets
            title={menuLayout.MenuItem19}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/assetItems"
        element={
          <AssetItems
            title={menuLayout.MenuItem20}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/assetsSSP"
        element={
          <AssetsSSP
            title={menuLayout.MenuItem21}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/incomeDynamics"
        element={
          <IncomeDynamics
            title={menuLayout.MenuItem22}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/leaseRegistry"
        element={
          <LeaseRegistry
            title={menuLayout.MenuItem24}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/leaseContracts"
        element={
          <LeaseContracts
            title={menuLayout.MenuItem25}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/procedureType"
        element={
          <ProcedureType
            title={menuLayout.MenuItem28}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/directionAnalysis"
        element={
          <DirectionAnalysis
            title={menuLayout.MenuItem29}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/analyticTotal"
        element={
          <AnalyticTotal
            title={menuLayout.MenuItem31}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/organizerResults"
        element={
          <OrganizerResults
            title={menuLayout.MenuItem33}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />
      <Route
        path="/disqualifiedBilling"
        element={
          <DisqualifiedBilling
            title={menuLayout.MenuItem36}
            menuItemsStrings={menuLayout}
            ExportChartFootnote={menuLayout.ExportChartFootnote}
            pageTitle={menuLayout.HeaderTitle}
          />
        }
      />

      {/* Catch-all: redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </RouterRoutes>
  );
}
